import {
    Action, getModule, Module, Mutation, VuexModule,
} from 'vuex-module-decorators';
import store from '@/state/store';
import Payload from '@/state/modules/payload';
import { sendGet, sendPost } from '@/api-client/api';
import { newsBannerAPI } from '@samclick-static-urls';


class NewsState {
    public loading: boolean = false

    public isBannerClosed: boolean = false

    public newsBanners: object = {}
}
@Module({
    namespaced: true,
    dynamic: true,
    store,
    name: 'news',
})
class NewsStore extends VuexModule {
    newsStore: NewsState = new NewsState();

  @Mutation
    NEWS_REINITIALIZE() {
        this.newsStore = new NewsState();
    }

  @Mutation
  SET_NEWS_LOADING(loading: boolean) {
      this.newsStore.loading = loading;
  }

  @Mutation
  SET_BANNER_IS_CLOSED(isBannerClosed: boolean) {
      this.newsStore.isBannerClosed = isBannerClosed;
  }

  @Action({ rawError: true })
  isBannerClosed(isBannerClosed: boolean) {
      this.context.commit('SET_BANNER_IS_CLOSED', isBannerClosed);
  }

  @Action({ rawError: true })
  showLoader(show: boolean) {
      this.context.commit('SET_NEWS_LOADING', show);
  }

  @Action({ rawError: true })
  destroyNews() {
      this.context.commit('NEWS_REINITIALIZE');
  }

  @Mutation
  SET_NEWS_SEARCH(response: object) {
      this.newsStore.newsBanners = response || {};
  }

  @Action({ rawError: true })
  getActiveNews(payload: Payload) {
      this.showLoader(payload.activateLoader);
      return new Promise((resolve, reject) => {
          sendGet(newsBannerAPI.getActiveNews, payload.data, true).then((response) => {
              if (payload.storeData) {
                  this.context.commit('SET_NEWS_SEARCH', response.data.value);
              }
              this.showLoader(false);
              resolve(response);
          }, (error) => {
              this.showLoader(false);
              reject(error.response);
          });
      });
  }
}

export default getModule(NewsStore);
